// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

/** CPT (AMA Current Procedural Terminology) coding system URL. */
export const CPT_SYSTEM = 'http://www.ama-assn.org/go/cpt';

/** CPT code for the at-home portable sleep apnea test (HSAT). */
export const HSAT_CPT_CODE = '95800';

/** Canonical URL of the HSAT ChargeItemDefinition seeded by `apps/provider-app/data/charge-item-definitions.json`. */
export const HSAT_CHARGE_ITEM_DEFINITION_URL = 'http://polarissleep.com/charge-item-definitions/95800';

/** Convert a USD dollar amount to integer cents (Stripe's currency unit). Half-cent values round to nearest. */
export function dollarsToCents(amount: number): number {
  return Math.round(amount * 100);
}

/** Format a USD dollar amount as `$1,234.56`. */
export function formatUsd(amount: number): string {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
}
